import { ApiClient } from "../types/client.types";
import { AppContext } from "../types/context.types";
import { QueryFunction } from "../types/query.types";
import { createApiClient } from "./createApiClient";

/**
 * This function builds the cache key by capturing the URL that would be called
 * without actually making the API request. This is used to build the query key for
 * react-query.
 * @param queryFn: the query function that makes use of the api passed via context
 * @param context: the current context that would be passed to the queryFn if it were called
 */
export function getCacheKey<T>(
    queryFn: QueryFunction<T>,
    context: AppContext,
    scope?: string,
): string[] {
    const key: string[] = scope ? [scope] : [];

    const urlCapture = (url: string) => {
        if (url) key.push(url);
        return {} as any;
    };

    const apiCapture = {
        ...createApiClient(),
        get: urlCapture,
        post: urlCapture,
        put: urlCapture,
        delete: urlCapture,
        patch: urlCapture,
        isMock: true,
    } as any as ApiClient;

    const safeContext = { ...context, api: apiCapture };

    try {
        queryFn(safeContext);
    } catch (e) {
        return key.length > 0 ? key : ["no-cache-key"];
    }

    return key.length > 0 ? key : ["no-cache-key"];
}
